/**
 * TtfNameRecord.ts class for EJ2-PDF
 */
var TtfNameRecord = /** @class */ (function () {
    function TtfNameRecord() {
    }
    return TtfNameRecord;
}());
export { TtfNameRecord };
